import {RcfaComplianceData, complianceScoreColor} from '@domain/rcfa'
import {GaugeBar} from '@hconnect/uikit/src/lib2'

export const RcfaComplianceGaugeBar = ({rcfaCompliance}: {rcfaCompliance: RcfaComplianceData}) => {
  const completed = rcfaCompliance?.completedCount ?? 0
  const mandatory = rcfaCompliance?.totalMandatoryCount ?? 0

  return (
    <GaugeBar
      value={completed}
      maxValue={mandatory}
      color={complianceScoreColor(completed, mandatory)}
      customSubtitle={true}
      barHeight={12}
    />
  )
}
